export default "__VITE_ASSET__5KybfA4x__"